import React from 'react';

import FormItem from "./FormItem";
class RAcompType extends React.Component {
  constructor(){
    super();
    this.removeOverE = this.removeOverE.bind(this);
    this.addOverE = this.addOverE.bind(this);
    this.getScema = this.getScema.bind(this);
    this.updateExtra = this.updateExtra.bind(this);
    this.updateContent = this.updateContent.bind(this);
    this.addContent = this.addContent.bind(this);
  }
  getScema(type)
  {
    switch (type) {
      case "yesNo":
        return {
          langCode: "",
          content: []
        };
        break;
      case "inputs":
        return {
          "DK": "",
          "UK": "",
        };
        break;
      case "checkbox":
        return {
                "from": 0,
                "to": 0
            };
        break;
      case "yesNoContent":
        return {
                "DK": "",
                "UK": "",
                "points": 0
            };
        break;
      default:
        return [];
        break;
    }
  }
  addContent(i)
  {
    var extra = [...this.props.d.extra];
    extra[i].content.push(this.getScema(this.props.d.type + "Content"));
    this.props.update("extra", extra);
    /*extra.push(this.getScema(this.props.d.type));
    this.props.update("extra", extra, "content");*/
  }
  updateContent(i, num, type, val)
  {
    var extra = [...this.props.d.extra];
    extra[i].content[num][type] = val;
    this.props.update("extra", extra);
  }
  updateExtra(i, type, val)
  {
    var extra = [...this.props.d.extra];
    extra[i][type] = val;
    this.props.update("extra", extra);
  }
  addOverE(e){
    if(e)
    {
      e.preventDefault();
    }

    var extra = [...this.props.d.extra];
    extra.push(this.getScema(this.props.d.type));
    this.props.update("extra", extra);
  }
  removeOverE(e, key, subKey){
    console.log(e, key, subKey);
    if(e)
    {
      e.preventDefault();
    }

    /*var extra = [...this.props.d.extra];
    console.log(extra, key, extra[key]);
    if(subKey)
    {
      delete extra[key].content[subKey];
    }else{
      delete extra[key];
    }
    console.log(extra, key, extra[key]);
    //extra.push(this.getScema(this.props.d.type));*/

    if(subKey)
    {
      const EXTRA = [...this.props.d.extra];
      EXTRA[key].content = EXTRA[key].content.filter((d,dKey) => dKey !== subKey);
      this.props.update("extra", EXTRA);
    }else{
      this.props.update("extra", [...this.props.d.extra].filter((d, dKey) => dKey !== key));
    }
  }

	render(){
    const p = this.props.p;
    const d = this.props.d;
    //console.log("RAcompType", this.props);
    switch (d.type) {
      case false:
        return null;
        break;
      case "signature":
          return null;
          break;
      case "drawing":
        return (
          <td colSpan="6" style={{"width": "100%"}}>
            <FormItem name="Baggrund">
              <input name="fact" style={{width: "100%", marginTop: "10px"}} placeholder="DK" onChange={(e) => this.props.update("DK", e.target.value, "fact")} disabled={d.dbID} defaultValue={d.fact ? d.fact.DK : ""}/>
            </FormItem>
          </td>);
          break;
      case "note":
          return null;
          break;
      case "title":
        return null;
        break;
      case "map":
        return null;
        break;
      case "yesNo":
        return (
          <td colSpan="6" style={{"width": "100%"}}>
            <FormItem name="Fact">
              <input name="fact" style={{width: "100%", marginTop: "10px"}} placeholder="DK" onChange={(e) => this.props.update("DK", e.target.value, "fact")} disabled={d.dbID} defaultValue={d.fact ? d.fact.DK : ""}/>
              <input name="fact" style={{width: "100%", marginTop: "10px"}} placeholder="UK" onChange={(e) => this.props.update("UK", e.target.value, "fact")} disabled={d.dbID} defaultValue={d.fact ? d.fact.UK : ""}/>
            </FormItem>
            <button onClick={(e) => this.addOverE(e)}>+</button>

            {
              d.extra.map((dat, key) => 
              <div className="item form-group" key={"yesNoR" + key}>
                <button onClick={(e) => this.removeOverE(e, key)}>Fjern</button>
                <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">
                  <select name="langCode" style={{maxWidth: "100%"}} defaultValue={dat.langCode ? dat.langCode : false} onChange={(e) => /*this.props.update("langCode", e.target.value)*/this.updateExtra(key, "langCode", e.target.value)}>
                    {
                        Object.keys(p.appLang).map((d,key) => <option key={"sand" + d + key} value={d}>{p.appLang[d]}</option>)
                    }
                  </select> 
                  <span className="required">*</span>
                </label>
                <div className="col-md-9 col-sm-9 col-xs-12">
                  <table className="table table-striped jambo_table bulk_action" id="sand">
                    <tbody>
                      <tr className="headings">
                        <th className="column-title">Tekst </th>
                        <th className="column-title" style={{width: "50px"}}>Point </th>
                        <th className="column-title" style={{width: "50px"}} onClick={() => this.addContent(key)}>+ </th>
                      </tr>
                      {
                        dat.content.map((content, cKey) => 
                          <tr key={d.type + cKey}>
                            <td className=" ">
                              <input style={{"width": "100%"}} disabled={d.dbID} name="textsand[]" onChange={(e) => this.updateContent(key, cKey, "DK", e.target.value)} type="text" defaultValue={content.DK}/>
                              <input style={{"width": "100%"}} disabled={d.dbID} name="textsand[]" onChange={(e) => this.updateContent(key, cKey, "UK", e.target.value)} type="text" defaultValue={content.UK}/>
                            </td>
                            <td className=" ">
                              <input type="number" name="pointsand[]" disabled={d.dbID} onChange={(e) => this.updateContent(key, cKey, "points", e.target.value)} defaultValue={content.points}/>
                            </td>
                            <td className=" last">
                              <button onClick={(e) => this.removeOverE(e, key, cKey)}>Fjern</button>
                            </td>
                        </tr>)
                      }
                    </tbody>
                  </table>
                </div>
              </div>)
            }

          </td>
          );
        break;
      case "inputs":
        return (<td colSpan="6" style={{"width": "100%"}}>
                  <FormItem name="Tekst-felter" must="1">
                      <table className="table table-striped jambo_table bulk_action" id="sand">
                          <tbody>
                              <tr className="headings">
                                  <th className="column-title">DK </th>
                                  <th className="column-title" style={{width: "50px"}}>UK </th>
                                  <th className="column-title" onClick={this.addOverE}>+</th>
                              </tr>
                            {
                                d.extra.map((extra, eKey) => {
                                    return (<tr key={d.type + eKey}>
                                                <td className=" ">
                                                    <input style={{"width": "100%"}} name="textsand[]" onChange={(e) => this.updateExtra(eKey, "DK", e.target.value)} disabled={d.dbID} type="text" defaultValue={extra.DK}/>
                                                </td>
                                                <td className=" ">
                                                    <input type="text" disabled={d.dbID} name="pointsand[]" onChange={(e) => this.updateExtra(eKey, "UK", e.target.value)} defaultValue={extra.UK}/>
                                                </td>
                                            </tr>);
                                })
                            }
                          </tbody>
                      </table>
                  </FormItem>
              </td>);
        break;
      case "checkbox":
        return (<td colSpan="6" style={{"width": "100%"}}>
                  <FormItem name="Vudering" must="1">
                      <table className="table table-striped jambo_table bulk_action" id="sand">
                          <tbody>
                              <tr className="headings">
                                  <th className="column-title">Fra </th>
                                  <th className="column-title" style={{width: "50px"}}>Til </th>
                                  <th className="column-title" onClick={() => this.addOverE()}>+</th>
                              </tr>
                              {
                                d.extra.map((extra, eKey) => {
                                    return (<tr key={d.type + eKey}>
                                              <td className=" ">
                                                <input style={{"width": "100%"}} name="textsand[]" onChange={(e) => this.updateExtra(eKey, "from", Number(e.target.value))} disabled={d.dbID} type="number" defaultValue={extra.from}/>
                                              </td>
                                              <td className=" ">
                                                <input type="number" disabled={d.dbID} name="pointsand[]" onChange={(e) => this.updateExtra(eKey, "to", Number(e.target.value))} defaultValue={extra.to}/>
                                              </td>
                                            </tr>);
                                })
                              }
                          </tbody>
                      </table>
                  </FormItem>
              </td>);
        break;
      case "dbz":
        return (<td colSpan="6" style={{"width": "100%"}}>
                  <FormItem name="Database kompnent" must="1">
                    <select name="DB" onChange={(e) => {
                      console.log("DB", Number());
                      console.log(p.questions[Number(e.target.value)]);
                      const dbComp = p.questions[Number(e.target.value)];
                      
                      this.props.overrideComp({
                            type: dbComp.type,
                            dbID: dbComp.id,
                            comment: dbComp.canComment === "1",
                            upload: dbComp.canUpload === "1",
                            shuffle: dbComp.shuffle === "1",
                            text: {
                                DK: dbComp.DK,
                                UK: dbComp.UK
                            },
                            correct: Number(dbComp.correct),
                            fact: dbComp.fact,
                            extra: []
                        });
                    }}>
                        <option></option>
                        {
                            p.questions.map((comp, key) => {
                                return <option key={"DB" + key} value={key}>[{comp.id}, {comp.type}] {comp.DK}</option>
                            })
                        }
                        
                    </select>
                  </FormItem>
              </td>);
        break;
      default:
        return (<div>[{d.type}] Unkown type..</div>);
        break;
    }
	}
}

export default RAcompType;


// WEBPACK FOOTER //
// ./src/components/RAcompType.js